import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { TypedMemo } from '../../../common/types';
import { AddByUrlForm } from './AddByUrlForm';
import { findMessages as messages } from './findMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** No target of this kind yet: the empty line and "Add by link". */
const FindEmptyComponent: React.FC<{ accountId: number }> = ({ accountId }) => {
  const intl = useIntl();
  return (
    <div className={styles.empty} data-testid="find-empty">
      <span className={styles.emptyIcon}>
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </span>
      <h3 className={styles.h2}>{intl.formatMessage(messages.empty)}</h3>
      <p className={styles.sub}>{intl.formatMessage(messages.emptyBody)}</p>
      <AddByUrlForm accountId={accountId} />
    </div>
  );
};

export const FindEmpty = TypedMemo(FindEmptyComponent);
